import { VisionLinkHealthDataProp } from '../../../types';
import { CatIconHealth } from '@blocks-react/components/Icons/Health';
import { CatHeading } from '@blocks-react/components/Heading';
import styles from '../../../VisionLink.module.scss';
import cx from 'classnames';

export const EquipmentHealth = ({
  healthLabel,
  children
}: VisionLinkHealthDataProp) => {
  return (
    <div className="d-flex">
      <div className={styles['no-health-issue-detected']}>
        <CatIconHealth className="u-color--MediumGray" />
      </div>
      <div className="ms-2">
        <CatHeading variant="body-sm">
          <span
            className={cx(
              'align-items-baseline',
              styles['c-vision-link-cards-text']
            )}
          >
            {healthLabel}
          </span>
        </CatHeading>
        <div
          className={cx(
            'd-flex mt-2 align-items-center flex-md-wrap text-nowrap',
            styles['c-vision-link-card-text-wrap']
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
